import React, { useEffect, useState } from "react";
import { Container, Table, Alert, Spinner, Button, Modal, Form } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { get, post, put, del } from "../../services/Services";
import { FaEdit, FaTrash } from "react-icons/fa";


const FinancialMovements = () => {
  const location = useLocation();
  const configId = location.state?.ConfigId;
  const [editingMovementId, setEditingMovementId] = useState(null);
  const [movements, setMovements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [newMovement, setNewMovement] = useState({
    date: "",
    description: "",
    amount: "",
    type: "income",
  });

  // Cargar movimientos financieros
  useEffect(() => {
    if (configId) {
      fetchMovements();
    }
  }, [configId]);

  const fetchMovements = async () => {
    try {
      const response = await get(`/api/academy/events/${configId}/financial-movements`);
      console.log("Respuesta de la API:", response); // Para verificar la estructura
  
      if (response?.data?.movements) {
        setMovements(response.data.movements);
      } else if (response?.movements) {
        setMovements(response.movements);
      } else {
        console.error("Estructura inesperada:", response);
      }
      
    } catch (error) {
      console.error("Error al cargar movimientos financieros:", error);
    } finally {
      setLoading(false);
    }
  };
  
  
  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewMovement({ ...newMovement, [name]: value });
  };

  const handleSaveMovement = async () => {
    const payload = {
      movementType: newMovement.type === "income" ? "INGRESO" : "EGRESO",
      description: newMovement.description,
      amount: parseFloat(newMovement.amount),
      date: newMovement.date,
    };
  
    try {
      if (editingMovementId) {
        // Modo edición → PUT
        await put(`/api/academy/events/${configId}/financial-movements/${editingMovementId}`, payload);
      } else {
        // Modo nuevo → POST
        await post(`/api/academy/events/${configId}/financial-movements`, payload);
      }
  
      setShowModal(false);
      setNewMovement({ date: "", description: "", amount: "", type: "income" });
      setEditingMovementId(null); // Muy importante resetear
      fetchMovements(); // Refresca la tabla
    } catch (error) {
      console.error("Error al guardar el movimiento:", error);
    }
  };
  
  

  // Asegurarse de que movements sea un array válido antes de usar reduce
  const totalIncome = Array.isArray(movements)
  ? movements.reduce(
      (acc, m) =>
        m.movementType === "INGRESO" || m.movementType === "INTERES"
          ? acc + m.amount
          : acc,
      0
    )
  : 0;
  const totalExpense = Array.isArray(movements)
  ? movements.reduce(
      (acc, m) =>
        ["EGRESO", "DESCUENTO"].includes(m.movementType)
          ? acc + m.amount
          : acc,
      0
    )
  : 0;

  const balance = totalIncome - totalExpense;

  const handleEdit = (movement) => {
    setNewMovement({
      date: movement.date,
      description: movement.description,
      amount: movement.amount,
      type: movement.movementType === "INGRESO" ? "income" : "expense",
    });
    setEditingMovementId(movement.id); // Guardamos el ID que estamos editando
    setShowModal(true);
  };

  const handleDelete = async (movement) => {
  const confirmDelete = window.confirm("¿Estás seguro de que querés eliminar este movimiento?");
  if (!confirmDelete) return;

  try {
    await del(`/api/academy/events/${configId}/financial-movements/${movement.id}`);
    fetchMovements(); // Refresca la tabla
  } catch (error) {
    console.error("Error al eliminar el movimiento:", error);
  }
};

  
  

 

  return (
    <Container className="mt-4 pb-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="fw-bold">Movimientos Financieros</h2>
        <Button 
  variant="primary" 
  onClick={() => {
    setEditingMovementId(null); // Asegura que NO estamos editando
    setNewMovement({ date: "", description: "", amount: "", type: "income" }); // Limpia los campos
    setShowModal(true);
  }}
>
  + Agregar Movimiento
</Button>
      </div>

      {loading ? (
        <div className="text-center mt-4">
          <Spinner animation="border" />
        </div>
      ) : (
        <Table striped bordered hover className="text-center mt-2">
          <thead className="table-primary">
            <tr>
              <th>Fecha</th>
              <th>Descripción</th>
              <th>Ingreso ($)</th>
              <th>Egreso ($)</th>
              <th>Acciones</th> 
            </tr>
          </thead>
          <tbody>
            {movements.length > 0 ? (
              movements.map((mov, index) => (
                <tr key={index}>
                  <td>{mov.date}</td>
                  <td>{mov.description}</td>
                  <td className="text-success">
                    {["INGRESO", "INTERES"].includes(mov.movementType)
                      ? `$ ${mov.amount.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                      : "-"}
                  </td>
                  <td className="text-danger">
                    {["EGRESO", "DESCUENTO"].includes(mov.movementType)
                      ? `$ ${mov.amount.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                      : "-"}
                  </td>

                  <td>
                    <Button variant="warning" size="sm"  onClick={() => handleEdit(mov)}> <FaEdit/></Button> {/* Botón para editar */}
                    <Button variant="danger" size="sm"  onClick={() => handleDelete(mov)}> <FaTrash/></Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No hay movimientos financieros registrados</td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr className="fw-bold table-secondary">
              <td colSpan="2" className="text-end">Total Ingresos:</td>
              <td className="text-success">$ {totalIncome.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
              <td></td>
            </tr>
            <tr className="fw-bold table-secondary">
              <td colSpan="3" className="text-end">Total Egresos:</td>
              <td className="text-danger">$ {totalExpense.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
            </tr>
            <tr className={`fw-bold ${balance >= 0 ? "table-success" : "table-danger"} fs-4`}>
              <td colSpan="3" className="text-end">Balance (Ingreso - Egreso):</td>
              <td>$ {balance.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
            </tr>
          </tfoot>
        </Table>
      )}

      {/* Modal para nuevo movimiento */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
        <Modal.Title>{editingMovementId ? "Editar Movimiento" : "Agregar Movimiento"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Fecha</Form.Label>
              <Form.Control type="date" name="date" value={newMovement.date} onChange={handleInputChange} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Descripción</Form.Label>
              <Form.Control type="text" name="description" value={newMovement.description} onChange={handleInputChange} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Importe</Form.Label>
              <Form.Control type="number" name="amount" value={newMovement.amount} onChange={handleInputChange} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Tipo</Form.Label>
              <Form.Select name="type" value={newMovement.type} onChange={handleInputChange}>
                <option value="income">Ingreso</option>
                <option value="expense">Egreso</option>
                <option value="income">Interes</option>
                <option value="expense">Descuento</option>
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
          <Button variant="primary" onClick={handleSaveMovement}>Guardar</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default FinancialMovements;
